import { connect, useSelector } from 'react-redux';

import { MedicalInsuranceAgreementsPriceList } from '../../../models/Entities/MedicalInsuranceAgreements/MedicalInsuranceAgreementsPriceList';
import { MedicalInsuranceAgreement } from '../../../models/Entities/MedicalInsuranceAgreements/MedicalInsuranceAgreement';
import { AppState } from '../../../redux/reducers';

import * as MedicalInsuranceAgreementPriceListStore from '../../../redux/middleware/MedicalInsuranceAgreementsMiddleware';
import { PriceListInfoPanel } from './PriceListInfoPanel';

export interface IProps {
  AgreementPriceList: MedicalInsuranceAgreementsPriceList;
}

interface DispatchProps {
  SetPriceListStartValidity: typeof MedicalInsuranceAgreementPriceListStore.actionCreators.SetPriceListStartValidity;
  SetPriceListEndValidity: typeof MedicalInsuranceAgreementPriceListStore.actionCreators.SetPriceListEndValidity;
}

type Props = IProps & DispatchProps;

const PriceListInfoComponentBase = (props: Props) => {
  const liveState = useSelector((state: AppState) =>
    state.MedicalInsuranceAgreements?.list
      .find(
        (agreement: MedicalInsuranceAgreement) =>
          agreement.id === props.AgreementPriceList.agreementId
      )
      ?.priceLists.find(
        (priceList: MedicalInsuranceAgreementsPriceList) =>
          priceList.id === props.AgreementPriceList.id
      )
  );

  const current = liveState ?? props.AgreementPriceList;

  return (
    <PriceListInfoPanel
      priceList={current}
      i18nRoot="priceListInfo"
      onConfirmStartValidity={(date) =>
        props.SetPriceListStartValidity(props.AgreementPriceList, date)
      }
      onConfirmEndValidity={(date) =>
        props.SetPriceListEndValidity(props.AgreementPriceList, date)
      }
    />
  );
};

const mapDispatchToProps = {
  SetPriceListStartValidity:
    MedicalInsuranceAgreementPriceListStore.actionCreators.SetPriceListStartValidity,
  SetPriceListEndValidity:
    MedicalInsuranceAgreementPriceListStore.actionCreators.SetPriceListEndValidity
};

export const PriceListInfoComponent = connect(
  null,
  mapDispatchToProps
)(PriceListInfoComponentBase as any) as any;

export default PriceListInfoComponent;
